import { Dropdown } from "react-bootstrap";
import "./DashboardPage.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import graph1 from "../assets//img/graph1.png";
import graph2 from "../assets/img/graph2.png";

function DashboardPage() {
  const notify = () => {
    toast.info("This functionality exceeded the scope of this project.", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  return (
    <div className="container-fluid position-relative animate__animated animate__fadeIn">
      <ToastContainer />
      <div className="d-sm-flex align-items-center justify-content-between mb-4 dashboard-pages">
        <h1 className="h3 mb-0">Dashboard</h1>
        <button className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
          <i className="fas fa-download fa-sm text-white-50"></i> Generate
          Report
        </button>
      </div>

      <div className="row">
        <div className="col-xl-3 col-md-6 mb-4">
          <div
            onClick={notify}
            className="card pointer top-row-card border-4 border-primary border-top-0 border-end-0 border-bottom-0 shadow h-100 py-2"
          >
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                    Earnings (Monthly)
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    $40,000
                  </div>
                </div>
                <div className="col-auto">
                  <i className="bi bi-calendar3 fs-2 text-secondary"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div
            onClick={notify}
            className="card pointer top-row-card border-4 border-success border-top-0 border-end-0 border-bottom-0 shadow h-100 py-2"
          >
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                    Earnings (Annual)
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    $215,000
                  </div>
                </div>
                <div className="col-auto">
                  <i className="bi bi-currency-dollar fs-2 text-secondary"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div
            onClick={notify}
            className="card pointer top-row-card border-4 border-danger border-top-0 border-end-0 border-bottom-0 shadow h-100 py-2"
          >
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">
                    Tasks
                  </div>
                  <div className="row no-gutters align-items-center">
                    <div className="col-auto">
                      <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">
                        50%
                      </div>
                    </div>
                    <div className="col">
                      <div className="progress progress-sm mr-2">
                        <div
                          className="progress-bar progress-bar-1 bg-danger"
                          role="progressbar"
                          aria-valuenow="50"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <i className="bi bi-clipboard-data fs-2 text-secondary"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div
            onClick={notify}
            className="card pointer top-row-card border-4 border-warning border-top-0 border-end-0 border-bottom-0 shadow h-100 py-2"
          >
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                    Pending Requests
                  </div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    18
                  </div>
                </div>
                <div className="col-auto">
                  <i className="bi bi-chat-dots fs-2 text-secondary"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row pb-3 d-xl-flex d-lg-none">
        <div className="col-xl-8 col-lg-7">
          <div className="card shadow h-100 mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-primary">
                Earnings Overview
              </h6>
              <Dropdown align="end">
                <Dropdown.Toggle
                  className="no-arrow rounded-circle p-0"
                  variant="transparent"
                  id="dropdown-basic"
                >
                  <i className="bi bi-three-dots-vertical fs-5 text-secondary"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={notify} href="#/action-1">
                    Action
                  </Dropdown.Item>
                  <Dropdown.Item onClick={notify} href="#/action-2">
                    Another action
                  </Dropdown.Item>
                  <Dropdown.Item onClick={notify} href="#/action-3">
                    Something else
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="card-body">
              <div className="chart-area pt-5">
                <img
                  onClick={notify}
                  className="img-fluid chart-img"
                  src={graph1}
                  alt="graph1"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4 h-100">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-primary">
                Revenue Sources
              </h6>
              <Dropdown align="end">
                <Dropdown.Toggle
                  className="no-arrow rounded-circle p-0"
                  variant="transparent"
                  id="dropdown-basic"
                >
                  <i className="bi bi-three-dots-vertical fs-5 text-secondary"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={notify} href="#/action-1">
                    Action
                  </Dropdown.Item>
                  <Dropdown.Item onClick={notify} href="#/action-2">
                    Another action
                  </Dropdown.Item>
                  <Dropdown.Item onClick={notify} href="#/action-3">
                    Something else
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="card-body">
              <div className="chart-pie pb-2">
                <img
                  onClick={notify}
                  className="img-fluid chart-img"
                  src={graph2}
                  alt="graph2"
                />
              </div>
              <div className="mt-4 text-center small">
                <span className="mr-2">
                  <i className="fas fa-circle text-primary"></i> Direct
                </span>
                <span className="mr-2">
                  <i className="fas fa-circle text-success"></i> Social
                </span>
                <span className="mr-2">
                  <i className="fas fa-circle text-info"></i> Referral
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6 mb-4">
          <div onClick={notify} className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Projects</h6>
            </div>
            <div className="card-body">
              <h4 className="small font-weight-bold">
                Server Migration <span className="float-right">20%</span>
              </h4>
              <div className="progress mb-4">
                <div
                  className="progress-bar progress-bar-2 bg-danger"
                  role="progressbar"
                  aria-valuenow="20"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h4 className="small font-weight-bold">
                Sales Tracking <span className="float-right">40%</span>
              </h4>
              <div className="progress mb-4">
                <div
                  className="progress-bar progress-bar-3 bg-warning"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h4 className="small font-weight-bold">
                Customer Database <span className="float-right">60%</span>
              </h4>
              <div className="progress mb-4">
                <div
                  className="progress-bar progress-bar-4"
                  role="progressbar"
                  aria-valuenow="60"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h4 className="small font-weight-bold">
                Payout Details <span className="float-right">80%</span>
              </h4>
              <div className="progress mb-4">
                <div
                  className="progress-bar progress-bar-5 bg-info"
                  role="progressbar"
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h4 className="small font-weight-bold">
                Account Setup <span className="float-right">Complete!</span>
              </h4>
              <div className="progress">
                <div
                  className="progress-bar progress-bar-6 bg-success"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6 mb-4">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">DataBase</h6>
            </div>
            <div className="card-body">
              <div className="text-center">
                {/* <img
                  className="img-fluid px-3 px-sm-4 mt-3 mb-4"
                  style="width: 25rem;"
                  src="img/undraw_posting_photo.svg"
                  alt="..."
                /> */}
              </div>
              <p>
                For this project with chose to work with MySQL as our database
                and sequelize as ORM. Cillum esse cupidatat deserunt irure
                labore elit nulla dolore. Sit nisi aute reprehenderit laborum.
                Occaecat enim aute Lorem qui sit quis id eu exercitation
                exercitation do adipisicing nostrud.
              </p>
            </div>
          </div>

          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Image hosting
              </h6>
            </div>
            <div className="card-body">
              <p>
                Both our image-bucket and our database are hosted in{" "}
                <a href="https://supabase.com/">Supabase</a>. Sint excepteur qui
                mollit dolor non laboris qui dolor ex magna elit excepteur ut
                non. Laborum ut quis laboris ea veniam commodo nulla
                reprehenderit. Laboris officia cillum laboris ut enim. Voluptate
                dolor aute quis nulla laborum fugiat adipisicing magna fugiat id
                anim. Dolor qui reprehenderit esse occaecat minim deserunt eu.
                Do labore exercitation exercitation eiusmod incididunt.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
